import { StringField } from "../../../types/types";
import {
  CollapsibleTextModuleFields,
  CollapsibleTextModuleProps,
  CollapsibleTextModule,
} from "../types/CollapsibleTextModule.types";

export class CollapsibleTextModuleModel {
  private readonly fields?: CollapsibleTextModuleFields;

  constructor(props: CollapsibleTextModuleProps) {
    this.fields = props.fields;
  }

  get title(): StringField | undefined {
    return this.fields?.Title
  }

  get anchorID(): StringField | undefined {
    return this.fields?.AnchorID
  }

  get primaryText(): StringField | undefined {
    return this.fields?.PrimaryText
  }

  get secondaryText(): StringField | undefined {
    return this.fields?.SecondaryText
  }

  get learnMoreLabel(): StringField | undefined {
    return this.fields?.LearnMoreLabel
  }
}
